/* generated by pull.js */
const manifest = {
    "editorOnly": true,
    "noTranslations": true,
    "name": "Show full blocks in block palette on hover",
    "description": "When hovering the mouse over a block in the block palette, all blocks in the palette will no longer be cut off at the edge.",
    "tags": [
        "recommended"
    ],
    "enabledByDefault": false,
    "dynamicEnable": true,
    "dynamicDisable": true,
    "userstyles": [
        {
            "url": "userstyle.css"
        }
    ],
    "credits": [
        {
            "name": "Gandi-IDE",
            "link": "https://github.com/Gandi-IDE/"
        }
    ]
};
export default manifest;
